import { useMemo } from "react";
import { loggedUserTypes } from "../types/auth.types";

/**
 * Hook to extract delivery addresses for a specific subscriber.
 * Consolidates the repeated address filtering logic used across multiple components.
 *
 * @param subscriberId - The subscriber ID to filter addresses for
 * @param userData - The user data containing subscribers and their addresses
 * @returns Array of delivery address strings
 */
export function useDeliveryAddresses(
    subscriberId: number | undefined | null,
    userData: loggedUserTypes
): string[] {
    return useMemo(() => {
        if (!subscriberId || !userData.subscribers) {
            return [];
        }

        return (
            userData.subscribers
                ?.filter((sub) => sub.subscriber_id === subscriberId)
                .flatMap((s) => s.delivery_adresses.map((a) => a.adress)) ?? []
        );
    }, [subscriberId, userData.subscribers]);
}
